export const initialFilterState = () => ({
  searchKey: "",
  role: "",
  page: 1,
  perPage: 10,
});
